export const state = () => ({
  redirectPath: false
})

export const mutations = {
  setRedirectPath(state, newRedirect) {
    state.redirectPath = newRedirect
  }
}

export const getters = {
  isAuthenticated(state) {
    return state.auth.loggedIn
  },

  loggedUser(state) {
    if (state.auth.loggedIn) {
      state.auth.user.isPressUser = function() {
        return this.roles.includes('press')
      } 
    }

    return state.auth.user
  },

  redirectPath(state) { return state.redirectPath }
}
